var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlayIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 112.45,
    height: 112.45,
    viewBox: "0 0 112.45 112.45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    "data-name": "Path 87",
    d: "M73.4,17.175a56.225,56.225,0,1,1-56.25,56.2,56.281,56.281,0,0,1,56.25-56.2M58.033,73.4c0,7.468.013,14.936-.013,22.4a2.875,2.875,0,0,0,1.341,2.855,2.817,2.817,0,0,0,3.13-.4q17.36-11.17,34.727-22.331c2.349-1.512,2.349-3.55,0-5.061Q79.859,59.7,62.493,48.538a2.824,2.824,0,0,0-3.13-.4A2.869,2.869,0,0,0,58.02,51c.025,7.468.013,14.936.013,22.4",
    transform: "translate(-17.147 -17.175)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayIcon);
export default __webpack_public_path__ + "static/media/play-icon.395b39a2407eca82e3cd21ccd707bb31.svg";
export { ForwardRef as ReactComponent };